export default __webpack_public_path__ + "static/media/accountBG.9dc64c4b.svg";